import React from "react";
import { Spinner } from "reactstrap";

//App
import useLoadingIndicatorStyles from "./styles";
import { LoadingIndicatorProps } from "../../../../types";

const LoadingIndicator: React.FC<LoadingIndicatorProps> = (props) => {
  const { notFullPage, size, style } = props;

  const loadingIndicatorStyles = useLoadingIndicatorStyles();
  return (
    <div
      style={{
        ...(!notFullPage ? loadingIndicatorStyles.container : {}),
      }}
    >
      <Spinner style={style} size={size} color="secondary"></Spinner>
    </div>
  );
};

export default LoadingIndicator;
